import { takeLatest } from 'redux-saga/effects';

import {
  FETCH_VEHICLES,
  getOperatorVehicles,
  UPDATE_VEHICLE,
  updateVehicle,
  BULK_UPDATE_VEHICLE,
  bulkUpdateVehicle,
} from './action';
import { REQUEST } from 'utils/actionGenerator';
import urlHelper from './api';
import { fetchEntitySpawn } from 'store/saga';

function* getOperatorVehiclesSaga(action) {
  const request = urlHelper.getVehiclesRequest(action.params);
  yield fetchEntitySpawn(request, getOperatorVehicles, action.params);
}

function* updateVehicleDetails(action) {
  const request = urlHelper.updateVehicle(action.params);
  yield fetchEntitySpawn(request, updateVehicle, {
    toaster: { successMsg: 'Request submitted successfully', errorMsg: 'Something went wrong' },
  });
}

function* bulkUpdateVehicleDetails(action) {
  const request = urlHelper.bulkUpdateVehicle(action.params);
  yield fetchEntitySpawn(request, bulkUpdateVehicle, {
    toaster: { successMsg: 'Request submitted successfully', errorMsg: 'Please enter correct vehicle data' },
  });
}

function* mySaga() {
  yield takeLatest(FETCH_VEHICLES[REQUEST], getOperatorVehiclesSaga);
  yield takeLatest(UPDATE_VEHICLE[REQUEST], updateVehicleDetails);
  yield takeLatest(BULK_UPDATE_VEHICLE[REQUEST], bulkUpdateVehicleDetails);
}

export default mySaga;
